import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-maintenance-mode',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './maintenance-mode.component.html',
  styleUrl: './maintenance-mode.component.scss',
})
export class MaintenanceModeComponent {}
